(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meltdown-presale-landing"] && !Shopify.designMode) return;
  try {
    
function initializeGiftSizes(root) {
  root.querySelectorAll('[data-gift-sizes]').forEach(group => {
    const card = group.closest('article');
    if (!card || group.dataset.initialized) return;
    group.dataset.initialized = 'true';
    group.hidden = false;
    card.querySelectorAll('[data-gift-price]').forEach(price => {
      price.hidden = price.dataset.giftPrice !== 'small';
    });
  });
}
initializeGiftSizes(document);
document.addEventListener('shopify:section:load', event => initializeGiftSizes(event.target));
document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-gift-choice]');
  if (!button) return;
  const group = button.closest('[data-gift-sizes]');
  const card = group && group.closest('article');
  if (!card) return;
  group.querySelectorAll('button').forEach(option => {
    option.setAttribute('aria-pressed', option === button ? 'true' : 'false');
  });
  const image = card.querySelector('img');
  if (image) {
    image.src = button.dataset.giftImage;
    image.alt = button.dataset.giftAlt;
  }
  card.querySelectorAll('[data-gift-price]').forEach(price => {
    price.hidden = price.dataset.giftPrice !== button.dataset.giftChoice;
    if (!price.hidden) {
      price.setAttribute('role', 'status');
      price.setAttribute('aria-live', 'polite');
    } else {
      price.removeAttribute('role');
      price.removeAttribute('aria-live');
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
